/*
 * @Description: 全局引入按需引入UI库 vant
 * @Author: shufei
 * @Date: 2021-11-04 20:31:40
 * @LastEditTime: 2021-11-19 09:24:52
 * @LastEditors: huangjing
 */
// 按需全局引入 vant组件
import Vue from 'vue'
import {
  Button,
  List,
  Cell,
  CellGroup,
  Loading,
  Tab,
  Tabs,
  Search,
  Skeleton,
  Image as VanImage,
  Tag,
  Overlay,
  RadioGroup,
  Radio,
  Popup,
  Dialog,
  ActionSheet,
  Uploader,
  Field,
  Swipe,
  SwipeItem,
  Switch,
  Icon,
  Toast,
  Lazyload,
  CheckboxGroup,
  Checkbox,
  Empty,
  ShareSheet,
  Picker,
  Form,
  Stepper,
  Circle,
  Area,
  DatetimePicker,
  DropdownMenu,
  DropdownItem,
  Collapse,
  CollapseItem,
  Popover,
  Badge,
  Steps,
  Step,
  SwipeCell,
  Divider,
  Calendar,
  Sticky,
  ImagePreview
} from 'vant'

Vue.use(Button)
Vue.use(Cell)
Vue.use(List)
Vue.use(Loading)
Vue.use(CellGroup)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Search)
Vue.use(Skeleton)
Vue.use(VanImage)
Vue.use(Tag)
Vue.use(Overlay)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(ActionSheet)
Vue.use(Uploader)
Vue.use(Field)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Switch)
Vue.use(Icon)
Vue.use(Toast)
Vue.use(Lazyload)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Empty)
Vue.use(ShareSheet)
Vue.use(Picker)
Vue.use(Form)
Vue.use(Stepper)
Vue.use(Circle)
Vue.use(Area)
Vue.use(DatetimePicker)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Popover)
Vue.use(Badge)
Vue.use(Steps)
Vue.use(Step)
Vue.use(SwipeCell)
Vue.use(Divider)
Vue.use(Calendar)
Vue.use(Sticky)
Vue.use(ImagePreview)
